"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const LeaseToOwnTermMappings = {
  MONTHLY: {
    perTermString: 'lto.perMonthLabel',
    termString: 'lto.monthsLabel',
    term: 'months'
  }
};
var _default = exports.default = LeaseToOwnTermMappings;